import { Link, useParams } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import { TroubleshootTranscript } from '../components/TroubleshootTranscript';

/** Full-page route for a single session transcript — used by deep-links + the device-drawer cards.
 *  The list page opens the same transcript in a slide-over instead. */
export function TroubleshootSessionView() {
  const { sessionId = '' } = useParams();
  return (
    <div className="flex flex-col gap-4 p-6" data-testid="troubleshoot-session-view">
      <Link
        to="/staff/troubleshoot"
        className="inline-flex w-fit items-center gap-1.5 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4 shrink-0" />
        {'Back to sessions'}
      </Link>
      <TroubleshootTranscript sessionId={sessionId} />
    </div>
  );
}
